import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import {
  IconButton,
  Link as MaterialLink,
  LinearProgress,
  FormControlLabel, FormHelperText,
} from "@material-ui/core";
import { FormErrors } from "../../../components/Login/FormErrors";
import enMsg from "__helpers/locale/en/en";
import Tooltip from "@material-ui/core/Tooltip";
import {
  PER_PAGE_OPTIONS,
  DEFAULT_PER_PAGE_RECORDS,
  ONLY_NUMBER_REGEX,
  MAX_INPUT_LENGTH,
  MAX_INPUT_LENGTH_LONG,
  PRIORITY_LIST,
  TASK_STATUS,
} from "__helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Slide,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import BlockIcon from "@material-ui/icons/Block";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FormGroup, FormControl, InputLabel } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment-timezone";
import MomentUtils from "@date-io/moment";
import { LocalizedUtils, UTCUtils } from "__helpers/util";
import Chip from "@material-ui/core/Chip";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import infoIcon from "assets/img/icons/info-icon.svg";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Scrollbars } from "react-custom-scrollbars";
import { connect } from "react-redux";

import { apiPath } from "api";
import {
  generalAuthTokenHeader,
  multimediaAuthTokenHeader,
} from "__helpers/auth-header";
import { userService } from "_services/user.service";
import { PATIENT_LIST } from "__helpers/constants";
import { formatDateToServerFormat } from "__helpers/util";
import { ALLOWED_PROFILE_IMAGE_SIZE } from "__helpers/constants";
import { ALLOWED_IMAGE_EXTENTION } from "__helpers/constants";
import { ALLOWED_FACESHEET_SIZE } from "__helpers/constants";
import { ALLOWED_FACESHEET_EXTENTION } from "__helpers/constants";
import Files from "react-files";
import { ReactUTCDatepicker } from "react-utc-datepicker";
import { formatDateToLocalFormat } from "__helpers/util";
import { localDateFormat } from "__helpers/util";
import { localServerFormat } from "__helpers/util";
import { localServerFormats } from "__helpers/util";
import { SELECTED_PATIENT_LIST } from "__helpers/constants";
import css from '../../../assets/css/addnewsurvey.css';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};
//moment.tz.setDefault("UTC");
export class PatientTasksClass extends Component {
  inputOpenImageFileRef = React.createRef(null);
  inputOpenFaceSheetFileRef = React.createRef(null);
  maxDate = new Date();
  minDate = new Date();
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));
    let patientId = JSON.parse(localStorage.getItem(SELECTED_PATIENT_LIST));

    this.dateUtility = new DateFnsUtils();
    this.state = {
      formErrors: {
        taskName: "",
        priority: "",
        description: "",
        changeStatus: "",
        notesStatus: "",
        dueDate: "",
      },
      taskNameValid: false,
      priorityValid: true,
      descriptionValid: true,
      changeStatusValid: true,
      notesStatusValid: true,
      dueDateValid: true,
      hasSurvey: false,
      sendImmediately: true, // default
      schedularDate: '',
      dischargePlannerId: userinfo.dischargePlanner.id,
      apiPartnerId: userinfo.dischargePlanner.facility.apiPartnerId,
      openContactDialog: false,
      spinner: spinner,
      contactName: "",
      patientEmail: "",
      phoneNumber: "",
      relationship: "",
      dob: "",
      patientId: patientId,
      selectedSurvey: '',
      surveys: [

      ],
      contactListpcc: [],
      contactTypeList: [],
      contactList: [],
      contactListFetched: false,
      selectedContactTypes: [],  // to hold contact types of the selected contact
      contactType: "",
      taskFetched: false,
      taskName: "",
      priority: "2",
      description: "",
      changeStatus: "4",
      notesStatus: "",
      gender: "",
      dueDate: null,
      hasSurvey: null,
      surveyFormId: null,
      schedularDate: null,
      sendLater: null,
      assigneeId: null,
      patientContactId: null,
      relationship: "",
      contactName: "",
      patientDetail: this.props.patientDetail,
      patientModalStatus: this.props.openTaskModal,
      patientTaskId: this.props.patientTaskId,
      taskUpdate: false,
      selectedSurveyId: "",
      showTimingOptions: false,
      sendLaterSelected: false,
      emailSend: null,
      delayTime: "",
      assigneeList: [],
      contactType: null,
      contactTypeList: [],
      manualDueDate: false


    };
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleDobDate = this.handleDobDate.bind(this);
    this.updateTasks = this.updateTasks.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchTasks = this.fetchTasks.bind(this);
    this.fetchContacts = this.fetchContacts.bind(this);

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.patientDetail && nextProps.patientDetail.patientId) {
      const isNewTask = !nextProps.patientTaskId;
      const taskName = isNewTask
        ? nextProps.suggestedTaskName || ""
        : nextProps.taskName || "";
      this.setState({
        patientDetail: nextProps.patientDetail,
        patientTaskId: nextProps.patientTaskId,
        taskName: taskName,
        priority: "2",
        description: "",
        hasSurvey: null,
        surveyFormId: null,
        schedularDate: null,
        sendLater: null,
        relationship: "",
        contactName: "",
        changeStatus: "4",
        notesStatus: "",
        gender: "",
        dueDate: null,
        assigneeId: this.state.dischargePlannerId,
        patientContactId: null,
      });

      if (nextProps.taskName) {
        this.setState({
          patientDetail: this.state.patientDetail,
          dueDate: null,
          taskName: taskName,
          taskNameValid: !!taskName,
          priorityValid: true,
          descriptionValid: true,
          changeStatusValid: true,
          notesStatusValid: true,
          dueDateValid: true,
          patientId: this.state.patientId,
          assigneeId: this.state.dischargePlannerId,
        }, () => {
          this.handleChangeInput({
            target: {
              name: 'taskName',
              value: taskName
            }
          });
        });
      } else if (nextProps.patientTaskId) {
        this.setState({
          dueDate: null,
          taskNameValid: true,
          priorityValid: true,
          descriptionValid: true,
          changeStatusValid: true,
          notesStatusValid: true,
          dueDateValid: true,
        });
      } else {
        this.setState({
          taskNameValid: !!taskName,
          priorityValid: true,
          descriptionValid: true,
          changeStatusValid: true,
          notesStatusValid: true,
          dueDateValid: true,
        });
      }

      // ? Add fetchContacts safely using .then()
      this.fetchContacts().then(() => {
        this.updatePrimaryContactSelection();
        if (nextProps.openTaskModal) {
          if (nextProps.patientTaskId && nextProps.patientTaskId != "") {
            this.setState(
              { taskUpdate: true },
              () => this.fetchTasks()
            );
          } else {
            this.setState({ taskUpdate: false });
          }
        }
      });
    }
  }

  async fetchSurvey() {
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    const apiUrl = apiPath.GetAllSurveyFormDropDown + this.state.dischargePlannerId;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("Survey Fetched: in Patient Task ", data);


      this.setState({ surveys: data }); // <-- now surveys have correct type

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }
  async componentDidMount() {
    await this.fetchContacts();
    //this.fetchPccContacts()
    this.fetchAssignee()
    this.fetchSurvey()

    const isUpdate = this.state.taskUpdate;
    console.log("In comMount task update: ", isUpdate)
    const emailSent = this.state.emailSend;
    console.log("In comMount email state: ", emailSent)
    if (!this.props.patientTaskId && this.props.suggestedTaskName) {
      this.setState({ taskName: this.props.suggestedTaskName });
      this.handleChangeInput({
        target: {
          name: 'taskName',
          value: this.props.suggestedTaskName
        }
      });
    }
    const {
      taskUpdate,
      emailSend,
      suggestedTaskName,
      priority,
      changeStatus,
      description,
      notesStatus,
      hasSurvey,
      dueDate,
      surveyFormId,
      contactName,
      phoneNumber,
      relationship,
      dob,
      contactType,
      patientContactId,
      patientEmail,
      schedularDate,
      sendImmediately,
      sendLater
    } = this.props;

    const initialState = {
      taskName: suggestedTaskName || "",
      priority: priority || (suggestedTaskName ? "2" : ""),
      changeStatus: changeStatus || (suggestedTaskName ? "4" : ""),
      description: description || "",
      notesStatus: notesStatus || "",
      dueDate: dueDate || null,
      hasSurvey: hasSurvey || false,
      sendLater: sendLater || false,
      surveyFormId: surveyFormId || null,
      schedularDate: schedularDate || null,
      relationship: relationship || "",
      contactName: contactName || "",
      patientContactId: patientContactId || null,
      contactTypeList: contactType || null,
      assigneeId: this.state.dischargePlannerId,
      // sendImmediately: sendImmediately || (taskUpdate
      //   ? emailSend === false
      //     ? "later"
      //     : "immediate"
      //   : "")
      sendImmediately: sendImmediately || (taskUpdate
        ? emailSend === false
          ? (sendLater == null ? "discharge" : "later")   // ? our condition
          : "immediate"
        : "")

    };
    // If editing existing task, set sendImmediately based on emailSend flag
    // if (isUpdate) {
    //   initialState.sendImmediately = emailSent === false ? "later" : "immediate";
    // }

    if (isUpdate) {
      if (emailSent === false) {
        initialState.sendImmediately = sendLater == null ? "discharge" : "later";
      } else {
        initialState.sendImmediately = "immediate";
      }
    }


    this.setState(initialState);
  }
  handleChangeInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      }
    );
  };
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let addressValid = this.state.addressValid;
    let statusValid = this.state.statusValid;

    let taskNameValid = this.state.taskNameValid;
    let priorityValid = this.state.priorityValid;
    let descriptionValid = this.state.descriptionValid;
    let genderValid = this.state.genderValid;
    let changeStatusValid = this.state.changeStatusValid;
    let notesStatusValid = this.state.notesStatusValid;
    let dueDateValid = this.state.dueDateValid;
    let estDateValid = this.state.estDateValid;
    let patientCategotiesValid = this.state.patientCategotiesValid;

    switch (fieldName) {
      case "taskName":
        taskNameValid = fieldValue.trim().length > 0;
        fieldValidationErrors.taskName = taskNameValid
          ? ""
          : enMsg.taskNameRequiredMsg;
        break;
      case "description":
        //descriptionValid = (fieldValue && fieldValue.trim().length > 0) || fieldValue == "" ? true : false;
        //fieldValidationErrors.description = descriptionValid ? '' : enMsg.descriptionRequiredMsg;
        break;
      case "priority":
        priorityValid = fieldValue == "" ? false : true;
        fieldValidationErrors.priority = priorityValid
          ? ""
          : enMsg.priorityRequiredMsg;
        break;
      case "changeStatus":
        changeStatusValid = fieldValue == "" ? false : true;
        fieldValidationErrors.changeStatus = !changeStatusValid
          ? enMsg.changeStatusRequiredMsg
          : "";
        break;
      case "notesStatus":
        //notesStatusValid = (fieldValue || fieldValue == "") ? true : false;
        //fieldValidationErrors.notesStatus = !notesStatusValid
        // ? enMsg.notesStatusRequiredMsg
        // : "";
        break;
      case "dueDate":
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        taskNameValid: taskNameValid,
        priorityValid: priorityValid,
        descriptionValid: descriptionValid,
        changeStatusValid: changeStatusValid,
        notesStatusValid: notesStatusValid,
        dueDateValid: dueDateValid,
      },
      this.validateForm
    );
  };
  validateForm() {
    return (
      this.state.taskNameValid &&
      this.state.priorityValid &&
      this.state.descriptionValid &&
      this.state.changeStatusValid &&
      this.state.notesStatusValid &&
      this.state.dueDateValid
    );
  }
  async fetchTasks() {
    if (!this.state.contactListFetched) {
      console.warn("? Contacts not fetched yet � delaying task fetch");
      return;
    }

    this.setState({
      loading: true,
    });
    let showNotification = {};
    let url = apiPath.patientTasks + "/" + this.state.patientTaskId;
    const response = await fetch(url, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.ok) {
        } else {
          showNotification = {
            title: "Task Fetch",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.id) {
          let localDueDateMoment = data.dueDate
            ? moment
              .utc(data.dueDate, "YYYY-MM-DD")
              .format("MM/DD/YYYY")
            : null;
          let patientContactId = data.patientContactId;

          if (!patientContactId) {
            if (data.contactName && data.relationship) {
              const matchedContact = this.state.contactList?.find(
                (c) =>
                  c.contactName === data.contactName &&
                  c.relationship === data.relationship
              );
              if (matchedContact) {
                patientContactId = matchedContact.patientContactId;
              }
            }

            // If still empty, fallback to primary contact
            if (!patientContactId) {
              const primaryContact = this.state.contactList?.find(c => c.isPrimary);
              if (primaryContact) {
                patientContactId = primaryContact.patientContactId;
              }
            }
          }
          let sendImmediatelyValue = "";
          if (data.emailSend === false) {
            if (data.sendLater == null || !data.sendLater) {   // or use !data.sendLater if false = null in your API
              sendImmediatelyValue = "discharge";
            } else {
              sendImmediatelyValue = "later";
            }
          } else if (data.emailSend === true) {
            sendImmediatelyValue = "immediate";
          }
          //console.log("sendImmediatelyValue-check", sendImmediatelyValue);
          this.setState({
            loading: false,
            taskName: data.taskName,
            priority: data.taskPriority,
            description: data.taskDescription,
            changeStatus: data.changeStatus,
            notesStatus: data.statusDescription,
            dueDate:localDueDateMoment,
            patientTaskId: data.id,
            surveyFormId: data.surveyFormId,
            hasSurvey: data.hasSurvey,
            sendLater: data.sendLater,
            contactName: data.contactName,
            phoneNumber: data.phoneNumber,
            relationship: data.relationship,
            dob: data.dob,
            patientContactId,
            taskFetched: true,
            patientEmail: data.patientEmail,
            emailSend: data.emailSend,
            schedularDate: data.schedularDate,
            //sendImmediately: "later",
            sendImmediately: sendImmediatelyValue,
            assigneeId: data.assigneeId,
            isPrimary: data.isPrimary,
            dischargeDateOption: data.sendLaterDays,
            manualDueDate: data.manualDueDate || false,
          });
        } else {
          showNotification = {
            title: "Task Fetch",
            message: "Bad response from server",
            type: "danger",
          };
          this.props.updatePatientModalClose();
          this.setState({
            loading: false,
          });
        }
      })
      .catch((error) => {
        showNotification = {
          title: "Task Fetch",
          message: "Bad response from server",
          type: "danger",
        };

        this.setState({
          loading: false,
        });
        return response;
      });
    userService.showNotification(showNotification);
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.contactList !== this.state.contactList &&
      this.state.patientContactId &&
      !this.state.contactList?.some(
        (c) => c.patientContactId === this.state.patientContactId
      )
    ) {
      // Try to match again by name + relationship
      const matched = this.state.contactList.find(
        (c) =>
          c.contactName === this.state.contactName &&
          c.relationship === this.state.relationship
      );
      if (matched) {
        this.setState({ patientContactId: matched.patientContactId });
      }
    }
  }

  handleSubmit = (event) => {
    this.setState({
      loading: true,
    });
    event.preventDefault();
    this.updateTasks();
  };
  handleContactSelect = (selectedId) => {
    const selectedContact = this.state.contactListpcc.find(
      (contact) => contact.pccContactListId === selectedId
    );

    if (selectedContact) {
      const contactInfo = {
        patientContactId: selectedContact.pccContactListId,
        contactName: `${selectedContact.firstName} ${selectedContact.lastName}`,
        patientEmail: selectedContact.email || "",
        phoneNumber: selectedContact.homePhone !== "N/A" ? selectedContact.homePhone : selectedContact.homePhone,
        relationship: selectedContact.relationship,
        dob: selectedContact.dob,
        isPccPatientContact: selectedContact.isPccPatientContact,
      };

      this.setState({
        pccContactListId: selectedId,
        contactInfo,
      });
    } else {
      // Reset if "None" selected
      this.setState({
        pccContactListId: "",
        contactInfo: {},
      });
    }
  };
  async updateTasks() {
    let showNotification = {};
    this.props.loaderStatus(true);
    let localDueDateMoment = null;

    const suggestedTaskName = this.props.suggestedTaskName || this.state.suggestion || "";

    localDueDateMoment = this.state.dueDate
      ? this.dateUtility.format(new Date(this.state.dueDate), "yyyy-MM-dd")
      : null;

    if (this.state.hasSurvey) {
      if (!this.state.surveyFormId) {
        this.setState({ loading: false });
        this.props.loaderStatus(false);
        userService.showNotification({
          title: "Validation Error",
          message: "Please select a survey.",
          type: "warning",
        });
        return;
      }

      if (!this.state.patientContactId) {
        console.log("Task patient valdiation: ", this.state.patientContactId)
        this.setState({ loading: false });
        this.props.loaderStatus(false);
        userService.showNotification({
          title: "Validation Error",
          message: "Please select a contact.",
          type: "warning",
        });
        return;
      }

    } const selectedContact = this.state.contactList.find(
      (item) => String(item.patientContactId) === String(this.state.patientContactId)
    );

    // ?? Check for primary contact with no email
    if (this.state.hasSurvey && selectedContact?.isPrimary && !selectedContact?.email) {
      this.setState({ loading: false });
      this.props.loaderStatus(false);
      userService.showNotification({
        title: "Missing Email",
        message: "Patient contact has no email.",
        type: "warning",
      });

      // Optionally, prevent setting the contact
      return;
    }




    const data = {
      patientId: this.props.patientDetail.patientId,
      taskName: this.state.taskName,
      dueDate: localDueDateMoment,
      changeStatus: this.state.changeStatus,
      statusDescription: this.state.notesStatus,
      taskPriority: this.state.priority,
      taskDescription: this.state.description,
      hasSurvey: this.state.hasSurvey,
      sendLater: this.state.sendLater,
      surveyFormId: this.state.surveyFormId || null,
      patientContactId: this.state.patientContactId || null,
      sendNow: this.state.sendImmediately === "immediate",
      schedularDate: this.state.sendImmediately === "immediate"
        ? null
        : this.state.schedularDate
          ? this.dateUtility.format(new Date(this.state.schedularDate), "yyyy-MM-dd")
          : this.state.schedularDate,
      emailSend: this.state.emailSend,
      assigneeId: this.state.assigneeId,
      manualDueDate: this.state.manualDueDate,
      ...(selectedContact && {
        contactName: selectedContact.contactName || '',
        patientEmail: selectedContact.email || '',
        phoneNumber: selectedContact.phoneNumber || '',
        relationship: selectedContact.relationship || '',
        dob: selectedContact.dob || '',
        isPccPatientContact: selectedContact.isPccPatientContact,
        sendLaterDays: this.state.dischargeDateOption,

      }),
    };
    let methodType = "POST";
    if (this.state.taskUpdate && this.state.patientTaskId) {
      data.id = this.state.patientTaskId;
      methodType = "PUT";
    }

    try {
      const response = await fetch(apiPath.patientTasks, {
        method: methodType,
        headers: generalAuthTokenHeader(),
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        showNotification = {
          title: enMsg.taskFailedTitle,
          message: result?.detail || "Unknown error occurred",
          type: "danger",
        };
      } else if (response.status === 400) {
        showNotification = {
          title: enMsg.taskFailedTitle,
          message: "Bad response from server",
          type: "danger",
        };
      } else {
        showNotification = {
          title: this.state.taskUpdate
            ? enMsg.taskUpdateTitle
            : enMsg.taskCreateTitle,
          message: this.state.taskUpdate
            ? enMsg.taskUpdateDes
            : enMsg.taskCreateDes,
          type: "success",
        };

        if (this.props.updatePatient) {
          this.props.updatePatient();
        }
        if (this.props.refreshTasks) {
          this.props.refreshTasks();
        }
        this.props.updatePatientModalClose();
      }
    } catch (error) {
      console.error("API error:", error);
      showNotification = {
        title: enMsg.taskFailedTitle,
        message: "Unexpected error occurred",
        type: "danger",
      };
    }

    this.setState({ loading: false });
    this.props.loaderStatus(false);
    userService.showNotification(showNotification);
  }
  handleDueDate = (value) => {
    let dueDateValid = true;
    if (value && !this.dateUtility.isValid(value)) {
      dueDateValid = false;
    }

    this.setState(
      {
        dueDate: value,
        dueDateValid,
        manualDueDate: true, // ? mark as user-chosen date
      },
      () => {
        this.validateField("dueDate", value);
      }
    );
  };

  handleDobDate = (value) => {
    let dob = true;
    if (value && !this.dateUtility.isValid(value)) {
      dob = false;
    }

    this.setState(
      {
        dob: value,
        dobDateValid: dob,
      },
      () => {
        this.validateField("dob", value);
      }
    );
  };
  handleDueDateError = (error, value) => {
    /* this.setState({
      dueDateValid: error ? false : true,
    }); */
  };

  handleOpenContactDialog = () => {
    this.setState({ openContactDialog: true });
  };

  handleCloseContactDialog = () => {
    this.setState({
      openContactDialog: false,
      contactName: "",
      contactEmail: "",
      contactPhone: ""
    });
  };


  handleToggleSurvey = (e) => {
    const checked = e.target.checked;
    this.setState({

      hasSurvey: checked, // update this field based on checkbox
    });
  };
  handleSurveyChange = (e) => {
    this.setState({ surveyFormId: e.target.value });
  };
  async fetchContacts() {
    if (!this.props.patientDetail || !this.props.patientDetail.patientId) {
      console.warn("Patient detail is missing, skipping contact fetch.");
      return;
    }

    this.state.spinner.removeAttribute("hidden");

    let showNotification = {};
    const apiUrl = apiPath.GetAllPatientContactList + "?patientId=" + this.props.patientDetail.patientId + "&dpId=" + this.state.dischargePlannerId;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("Contacts fetched:", data);

      // Set contact list first, then check for matching contactId to update contactInfo
      this.setState({ contactList: data, contactListFetched: true }, () => {
        const selectedId = this.state.patientContactId;
        if (selectedId) {
          const selectedContact = data.find(c => c.patientContactId === selectedId);
          if (selectedContact) {
            this.setState({
              contactInfo: {
                patientContactId: selectedContact.patientContactId,
                contactName: selectedContact.contactName || '',
                patientEmail: selectedContact.email || '',
                phoneNumber: selectedContact.phoneNumber || '',
                relationship: selectedContact.relationship || '',
                dob: selectedContact.dob || '',
                isPccPatientContact: selectedContact.isPccPatientContact,
              },
            });
          }
        }
      });

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching contacts", error);
      userService.showNotification({
        title: "Input Types",
        message: "Server Error",
        type: "danger",
      });
    }

    this.state.spinner.setAttribute("hidden", "true");
  }

  handleManualContactChange = (event) => {
    const selectedId = event.target.value;
    const { contactList, patientContactId: currentContactId } = this.state;

    if (!selectedId) {
      this.setState({
        patientContactId: "",
        contactInfo: null,
        contactTypeList: [],
        contactType: null,
      });
      return;
    }
    const selectedContact = contactList.find(
      c => String(c.patientContactId) === String(selectedId)
    );

    // Skip update if selection didn't actually change
    if (String(selectedId) === String(currentContactId)) {
      return;
    }

    // Validate primary contact requirements
    if (!selectedContact?.email) {
      userService.showNotification({
        title: "Primary Contact Required",
        message: "Primary contacts must have an email address.",
        type: "warning",
      });
      return;
    }

    // Prepare updated state
    const updates = {
      patientContactId: selectedId,
      contactInfo: selectedContact ? {
        patientContactId: selectedContact.patientContactId,
        contactName: selectedContact.contactName || '',
        patientEmail: selectedContact.email || '',
        phoneNumber: selectedContact.phoneNumber || '',
        relationship: selectedContact.relationship || '',
        dob: selectedContact.dob || null,  // More appropriate for dates
        isPccPatientContact: Boolean(selectedContact.isPccPatientContact),
        isPrimary: Boolean(selectedContact.isPrimary),
      } : null,  // Explicit null better than empty object
      contactType: selectedContact?.contactType || "",
      contactTypeList: selectedContact?.contactType || [],  // ? Set the array here
      contactType: null,
    };

    // Batch state update
    this.setState(updates, () => {
      // Optional callback after state is updated
      if (this.props.onContactChange) {
        this.props.onContactChange(selectedContact, updates.contactInfo);
      }

      // Additional validation if needed
      this.validateContactSelection();
    });
  };

  // Helper method for validation
  validateContactSelection = () => {
    const { patientContactId, contactList } = this.state;
    if (!patientContactId) return true;

    const contactExists = contactList.some(
      c => String(c.patientContactId) === String(patientContactId)
    );

    if (!contactExists) {
      this.setState({ patientContactId: '' });
    }
    return contactExists;
  };
  updatePrimaryContactSelection = () => {
    const { contactList, hasSurvey } = this.state;
    const primaryContact = contactList?.find((c) => c.isPrimary);

    if (hasSurvey !== false) {
      if (primaryContact) {
        this.setState({
          patientContactId: String(primaryContact.patientContactId),
          contactTypeList: primaryContact.contactType || [], // array of types for dropdown
          contactType: (primaryContact.contactType && primaryContact.contactType.length > 0)
            ? primaryContact.contactType[0]  // default to first contact type
            : null,
        });
      } else {
        this.setState({
          patientContactId: "",
          contactTypeList: [],
          contactType: null,
        });
      }
    }
  };


  handleAddContact = async () => {
    const {
      contactName,
      phoneNumber,
      patientEmail,
      dob,
      relationship,
    } = this.state;

    // Build the payload
    const payload = {
      name: contactName,
      phoneNumber: phoneNumber,
      email: patientEmail,
      dob: dob ? this.dateUtility.format(new Date(dob), "yyyy-MM-dd") : null,
      relationship: relationship,
      dpId: this.state.dischargePlannerId,
      patientId: this.props.patientDetail.patientId,
    };

    console.log("payload", payload);

    const apiUrl = apiPath.AddPatientContactSave;
    let showNotification = {};
    this.state.spinner.removeAttribute("hidden");

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 400) {
        showNotification = { title: "Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Survey", message: "Error submitting contact", type: "danger" };
      } else {
        showNotification = {
          title: "Contact",
          message: "Contact added successfully!",
          type: "success",
        };

        // Optionally update contact list or close dialog
        this.setState({ openContactDialog: false });

        // Refresh contact list if needed

      }

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error submitting contact", error);
      userService.showNotification({ title: "Contact", message: "Server Error", type: "danger" });
    }

    this.state.spinner.setAttribute("hidden", "true");
  };

  handlecalculateSchedularDate = (value) => {
    if (value >= 0) {

    }
  };

  resetState = () => {
    this.setState({
      taskName: '',
      taskNameValid: true,
      dueDate: null,
      dueDateValid: true,
      priority: '',
      priorityValid: true,
      description: '',
      descriptionValid: true,
      changeStatus: '',
      changeStatusValid: true,
      notesStatus: '',
      notesStatusValid: true,
      hasSurvey: false,
      sendLater: false,
      surveyFormId: '',
      patientContactId: '',
      schedularDate: null,
      emailSend: null,
      sendImmediately: true,
      formErrors: {}, // assuming you're tracking errors
      loading: false,
      taskUpdate: false,
      // Add more fields if your state has more properties
    });
  };
  componentDidUpdate(prevProps) {
    // When modal is opened AND we are in create mode (not update)
    if (
      !prevProps.open && this.props.open &&
      !this.state.taskUpdate // taskUpdate is false in create mode
    ) {
      this.resetState();
    }
  }
  async fetchAssignee() {

    let showNotification = {};
    const apiUrl = apiPath.GetAllAssignee
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        //showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        //showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();

      console.log("Assignee response: ", response);
      console.log("Assignee Fetched: ", data);
      console.log("AssigneeFetched: ", response.data);

      this.setState({
        assigneeList: Array.isArray(data) ? data : data ? [data] : []
      });


      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      //  showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

  }

  parseApiDate = (dateStr) => {
    if (!dateStr) return null;

    // Case 1: date-only (YYYY-MM-DD)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [year, month, day] = dateStr.split("-");
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    // Case 2: datetime (YYYY-MM-DDTHH:mm:ss)
    if (/^\d{4}-\d{2}-\d{2}T/.test(dateStr)) {
      const d = new Date(dateStr);
      // normalize to local midnight
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    return new Date(dateStr); // fallback
  };

  // formatDateString = (dateStr, format = "MM/dd/yyyy") => {
  //   if (!dateStr) return "";

  //   let dateObj;

  //   // If it's already a Date object
  //   if (dateStr instanceof Date) {
  //     dateObj = dateStr;
  //   } 
  //   // If it's a string like "2025-09-26"
  //   else if (typeof dateStr === "string" && dateStr.includes("-")) {
  //     const [year, month, day] = dateStr.split("-");
  //     dateObj = new Date(Number(year), Number(month) - 1, Number(day));
  //   } 
  //   // Fallback (just try to construct Date)
  //   else {
  //     dateObj = new Date(dateStr);
  //   }

  //   return this.dateUtility.format(dateObj, format);
  // };

  formatDateString = (dateStr, format = "MM/dd/yyyy") => {
    if (!dateStr) return "";

    let year, month, day;

    // Case 1: It's already a Date object
    if (dateStr instanceof Date) {
      year = dateStr.getFullYear();
      month = String(dateStr.getMonth() + 1).padStart(2, "0");
      day = String(dateStr.getDate()).padStart(2, "0");
    }
    // Case 2: ISO format with timezone or time part (e.g. 2025-09-04T00:00:00Z)
    else if (typeof dateStr === "string" && dateStr.includes("T")) {
      const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return "";
      [, year, month, day] = match;
    }
    // Case 3: Plain date string (e.g. 2025-09-04)
    else if (typeof dateStr === "string" && dateStr.includes("-")) {
      const [y, m, d] = dateStr.split("-");
      year = y;
      month = m.padStart(2, "0");
      day = d.padStart(2, "0");
    }
    // Case 4: Fallback (try constructing Date)
    else {
      const dateObj = new Date(dateStr);
      if (isNaN(dateObj)) return "";
      year = dateObj.getFullYear();
      month = String(dateObj.getMonth() + 1).padStart(2, "0");
      day = String(dateObj.getDate()).padStart(2, "0");
    }

    // Format output
    if (format === "yyyy-MM-dd") return `${year}-${month}-${day}`;
    if (format === "MM/dd/yyyy") return `${month}/${day}/${year}`;
    if (format === "dd/MM/yyyy") return `${day}/${month}/${year}`;

    // Default fallback
    return `${month}/${day}/${year}`;
  };


  pacificFormatDateString = (dateStr, format = "MM/dd/yyyy") => {
    if (!dateStr) return "";

    let dateObj;

    // Convert input into Date object
    if (dateStr instanceof Date) {
      dateObj = dateStr;
    } else {
      // Try parsing string (ISO or plain date)
      dateObj = new Date(dateStr);
      if (isNaN(dateObj)) return "";
    }

    // Convert to Pacific Time using Intl.DateTimeFormat
    const pacificFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    const [{ value: month }, , { value: day }, , { value: year }] = pacificFormatter.formatToParts(dateObj);

    // Format output
    if (format === "yyyy-MM-dd") return `${year}-${month}-${day}`;
    if (format === "MM/dd/yyyy") return `${month}/${day}/${year}`;
    if (format === "dd/MM/yyyy") return `${day}/${month}/${year}`;

    // Default fallback
    return `${month}/${day}/${year}`;
  };

  render() {
    const { patientContactId } = this.state
    const isSendLaterSelected = this.state.emailSend === null
      ? this.state.sendImmediately === false
      : this.state.emailSend === false;

    return (
      <Dialog
        open={this.props.openTaskModal}
        maxWidth={"sm"}
        onClose={this.props.updatePatientModalClose}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
        className="add-modal front-modal "
      >
        <DialogTitle className="add-modal-title" id="form-dialog-title">
          Task
          <IconButton
            className="closeButton"
            aria-label="close"
            onClick={() => {
              this.resetState(); // Clear form state
              this.props.updatePatientModalClose(); // Then close the modal
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {this.state.loading && <LinearProgress size={24} />}
        <form onSubmit={this.handleSubmit} noValidate>
          <DialogContent>
            <div className="task-for">
              {this.props.patientDetail
                ? `${this.props.patientDetail.lastName}, ${this.props.patientDetail.firstName}`
                : "Loading..."}
            </div>
            <Box display="flex" justifyContent="flex-start" mb={1} mt={1}>
              <Box width={1 / 2} pr={2}>
                <TextField
                  InputLabelProps={{ className: "required-label" }}
                  name="taskName"
                  label="Task Name"
                  value={this.state.taskName}
                  onChange={this.handleChangeInput}
                  inputProps={{ maxLength: MAX_INPUT_LENGTH }}
                />
                <FormErrors
                  show={!this.state.taskNameValid}
                  formErrors={this.state.formErrors}
                  fieldName="taskName"
                />
              </Box>
              <Box width={1 / 2} pl={2}>
                <FormControl variant="outlined">
                  <MuiPickersUtilsProvider
                    variant="outlined"
                    utils={DateFnsUtils}
                    moment={moment}
                  >
                    <KeyboardDatePicker
                      label="Due Date"
                      format="MM/dd/yyyy"
                      margin="normal"
                      id="start-date-picker-dialog"
                      name="dueDate"
                      animateYearScrolling={true}
                      value={this.state.dueDate}
                      minDateMessage={enMsg.taskMinDate}
                      onChange={this.handleDueDate}
                      onError={this.handleDueDateError}
                      className="KeyboardDatePicker"
                      invalidDateMessage={enMsg.invalidDate}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                        className: "date-picker-span",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                  <FormErrors
                    show={!this.state.dueDateValid}
                    formErrors={this.state.formErrors}
                    fieldName="dueDate"
                  />
                </FormControl>
              </Box>
            </Box>
            <Box display="flex" justifyContent="flex-start" mb={1}>
              <Box width={1 / 2} pr={2}>
                <FormControl>
                  <InputLabel className={"required-label"}>Priority</InputLabel>
                  <Select
                    id="priority"
                    color="secondary"
                    name="priority"
                    value={this.state.priority}
                    onChange={this.handleChangeInput}
                  >
                    <MenuItem value={""}>Select</MenuItem>
                    {PRIORITY_LIST
                      // .sort((a, b) => a.insuranceId > b.insuranceId ? 1 : -1)
                      .map((pList, key) => {
                        return (
                          <MenuItem key={key} value={pList.id}>
                            {pList.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  <FormErrors
                    show={!this.state.priorityValid}
                    formErrors={this.state.formErrors}
                    fieldName="priority"
                  />
                </FormControl>
              </Box>
              <Box width={1 / 2} pl={2}>
                <TextField
                  label="Description"
                  rows={4}
                  multiline={true}
                  fullWidth={true}
                  aria-label="validators"
                  name="description"
                  value={this.state.description}
                  onChange={this.handleChangeInput}
                  inputProps={{ maxLength: MAX_INPUT_LENGTH_LONG }}
                  className="comment-TextField"
                />
                <FormErrors
                  show={!this.state.descriptionValid}
                  formErrors={this.state.formErrors}
                  fieldName="description"
                />
              </Box>
            </Box>
            <Box display="flex" justifyContent="flex-start" mb={1}>
              <Box width={1 / 2} pr={2}>
                <FormControl>
                  <InputLabel className={"required-label"}>
                    Change Status
                  </InputLabel>
                  {/* <InputLabel>Insurance</InputLabel> */}
                  <Select
                    id="changeStatus"
                    color="secondary"
                    name="changeStatus"
                    value={this.state.changeStatus}
                    onChange={this.handleChangeInput}
                  >
                    <MenuItem value={""}>Select</MenuItem>
                    {TASK_STATUS
                      // .sort((a, b) => a.insuranceId > b.insuranceId ? 1 : -1)
                      .map((pList, key) => {
                        return (
                          <MenuItem key={key} value={pList.id}>
                            {pList.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  <FormErrors
                    show={!this.state.changeStatusValid}
                    formErrors={this.state.formErrors}
                    fieldName="changeStatus"
                  />
                </FormControl>
              </Box>
              <Box width={1 / 2} pl={2}>
                <TextField
                  value={this.state.notesStatus}
                  label="Status Change Notes"
                  rows={4}
                  multiline={true}
                  fullWidth={true}
                  aria-label="validators"
                  name="notesStatus"
                  onChange={this.handleChangeInput}
                  inputProps={{ maxLength: MAX_INPUT_LENGTH_LONG }}
                  className="comment-TextField"
                />
                <FormErrors
                  show={!this.state.notesStatusValid}
                  formErrors={this.state.formErrors}
                  fieldName="notesStatus"
                />
              </Box>

            </Box>
            <Box width={1 / 2} pr={2}>
              <FormControl fullWidth>
                <InputLabel>Assignee</InputLabel>
                <Select
                  value={this.state.assigneeId || ''}
                  onChange={(e) => this.setState({ assigneeId: e.target.value })}
                  disabled={this.state.emailSend === true}
                >
                  <MenuItem value="">None</MenuItem>
                  {this.state.assigneeList?.map((assignee, i) => (
                    <MenuItem key={i} value={assignee.assigneeId}>
                      {assignee.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <div style={{ borderTop: '1px solid #ccc', paddingTop: '10px', marginTop: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.hasSurvey}
                    onChange={this.handleToggleSurvey}
                    color="primary"
                    disabled={this.state.emailSend === true}
                  />
                }
                label="Add Survey"
                style={{
                  color: this.state.emailSend === true ? '#888' : 'inherit', // grey label when disabled
                  opacity: this.state.emailSend === true ? 0.6 : 1,           // optional: fade effect
                }}
              />

              {/* {this.state.schedularDate && this.state.hasSurvey && (
                this.state.emailSend === true ? (
                  <p style={{ color: 'red', marginTop: '8px' }}>
                    Mail already sent on {this.dateUtility.format(new Date(this.state.schedularDate), "MM/dd/yyyy")}
                  </p>
                ) : (
                  <p style={{ color: 'green', marginTop: '8px' }}>
                    Mail will be sent on {this.dateUtility.format(new Date(this.state.schedularDate), "MM/dd/yyyy")}
                  </p>
                )
              )} */}

              {this.state.schedularDate && this.state.hasSurvey && (
                this.state.emailSend === true ? (
                  <p style={{ color: 'red', marginTop: '8px' }}>
                    Mail already sent on {this.formatDateString(this.state.schedularDate, "MM/dd/yyyy")}
                  </p>
                ) : (
                  <p style={{ color: 'green', marginTop: '8px' }}>
                    Mail will be sent on {this.formatDateString(this.state.schedularDate, "MM/dd/yyyy")}
                  </p>
                )
              )}
{/* 
              {this.state.schedularDate && this.state.hasSurvey && (
                this.state.emailSend === true ? (
                  <p style={{ color: 'red', marginTop: '8px' }}>
                    Mail already sent on {this.pacificFormatDateString(this.state.schedularDate, "MM/dd/yyyy")}
                  </p>
                ) : (
                  <p style={{ color: 'green', marginTop: '8px' }}>
                    Mail will be sent on {this.pacificFormatDateString(this.state.schedularDate, "MM/dd/yyyy")}
                  </p>
                )
              )} */}

            </div>

            {this.state.hasSurvey && (
              <>
                <Box display="flex" gap={2} mt={2}>

                  {/* Survey Dropdown */}
                  <Box width={1 / 2} >
                    <FormControl fullWidth>
                      <InputLabel>Survey</InputLabel>
                      <Select
                        value={this.state.surveyFormId}
                        onChange={this.handleSurveyChange}
                        disabled={this.state.emailSend === true}
                      >
                        <MenuItem value="">None</MenuItem>
                        {this.state.surveys?.map((survey, i) => (
                          <MenuItem key={i} value={survey.formId}>
                            {survey.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                  <Box width={1 / 2} pr={2} ml={2}>
                    <FormControl fullWidth>
                      <InputLabel>Send Option</InputLabel>
                      {this.state.emailSend === true ? (
                        <Select value="immediate" disabled>
                          <MenuItem value="immediate">Send Immediately</MenuItem>
                        </Select>
                      ) : (
                        <Select
                          value={this.state.sendImmediately || ""}
                          onChange={(e) => {
                            const selected = e.target.value;

                            this.setState({
                              sendImmediately: selected,
                              sendLater: selected === "later",
                              schedularDate: selected === "later" ? this.state.schedularDate : "",
                              dischargeDateOption: selected === "discharge" ? this.state.dischargeDateOption : "",
                            });
                          }}
                        >

                          <MenuItem value="" disabled>Select Option</MenuItem>
                          <MenuItem value="immediate">Send Immediately</MenuItem>

                          {/* Discharge Date Option */}
                          {/* <MenuItem value="discharge">
                            {this.props.patientDetail.actualDischargeDate
                              ? "Actual Discharge Date: " + this.dateUtility.format(new Date(this.props.patientDetail.actualDischargeDate), 'dd-MMM-yyyy')
                              : this.props.patientDetail.eastimatedDischargeDate
                                ? "Expected Discharge Date: " + this.dateUtility.format(new Date(this.props.patientDetail.eastimatedDischargeDate), 'dd-MMM-yyyy')
                                : "N/A"}
                          </MenuItem> */}

                          <MenuItem value="discharge">
                            {this.props.patientDetail.actualDischargeDate
                              ? "Actual Discharge Date: " +
                              this.dateUtility.format(
                                this.parseApiDate(this.props.patientDetail.actualDischargeDate),
                                "dd-MMM-yyyy"
                              )
                              : this.props.patientDetail.eastimatedDischargeDate
                                ? "Expected Discharge Date: " +
                                this.dateUtility.format(
                                  this.parseApiDate(this.props.patientDetail.eastimatedDischargeDate),
                                  "dd-MMM-yyyy"
                                )
                                : "N/A"}
                          </MenuItem>


                          {/* New "Send Later" Option */}
                          <MenuItem value="later">Send Later (Pick Date)</MenuItem>
                        </Select>
                      )}
                    </FormControl>
                  </Box>

                </Box>

                {/* **ALL BELOW FIELDS ONLY SHOW IF hasSurvey === true** */}

                {/* Send Option + Date Picker (Grouped Together) */}
                <Box display="flex" gap={2} mt={2}>
                  {/* Send Option Dropdown */}

                  {/* Conditional Extra Fields */}
                  {this.state.sendImmediately === "discharge" && (
                    <Box width={1 / 2} pl={2}>
                      <FormControl fullWidth>
                        <InputLabel>Select days after discharge</InputLabel>
                        <Select
                          value={this.state.dischargeDateOption ?? ''}
                          onChange={(e) => {
                            const selectedDays = e.target.value;
                            let dischargeDate = null;

                            // Pick actual discharge date first, else estimated
                            // if (this.props.patientDetail.actualDischargeDate) {
                            //   dischargeDate = new Date(this.props.patientDetail.actualDischargeDate);
                            // } else if (this.props.patientDetail.eastimatedDischargeDate) {
                            //   dischargeDate = new Date(this.props.patientDetail.eastimatedDischargeDate);
                            // }

                            if (this.props.patientDetail.actualDischargeDate) {
                              dischargeDate = this.parseApiDate(this.props.patientDetail.actualDischargeDate);
                            } else if (this.props.patientDetail.eastimatedDischargeDate) {
                              dischargeDate = this.parseApiDate(this.props.patientDetail.eastimatedDischargeDate);
                            }

                            let newSchedularDate = "";
                            if (dischargeDate && selectedDays !== "") {
                              const resultDate = new Date(dischargeDate);
                              // ? Fix: directly add selectedDays
                              //resultDate.setDate(resultDate.getDate() + Number(selectedDays));
                              //newSchedularDate = resultDate.toISOString().split("T")[0]; // yyyy-mm-dd format
                              newSchedularDate = resultDate.setDate(resultDate.getDate() + Number(selectedDays));
                            }

                            // if (dischargeDate && selectedDays !== "") {
                            //   const resultDate = new Date(dischargeDate);
                            //   console.log("result date ;", resultDate);
                            //   resultDate.setDate(resultDate.getDate() + Number(selectedDays));

                            //   // Always store as yyyy-MM-dd (local date, no timezone shift)
                            //   const yyyy = resultDate.getFullYear();
                            //   const mm = String(resultDate.getMonth() + 1).padStart(2, "0");
                            //   const dd = String(resultDate.getDate()).padStart(2, "0");
                            //   newSchedularDate = `${yyyy}-${mm}-${dd}`;
                            //   console.log("newSchedularDate date ;", newSchedularDate);
                            // }


                            this.setState({
                              dischargeDateOption: selectedDays,
                              schedularDate: newSchedularDate,
                              sendLater: false,
                            });
                          }}

                          disabled={this.state.emailSend === true}
                        >
                          <MenuItem value="">Select Day</MenuItem>
                          {Array.from({ length: 31 }, (_, i) => i).map((day) => (
                            <MenuItem key={day} value={day}>
                              {day} days after discharge
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  )}

                  {this.state.sendImmediately === "later" && (
                    <Box width={1 / 2} pl={2}>
                      <FormControl fullWidth error={!this.state.schedularDate}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            label="Select Date"
                            format="MM/dd/yyyy"
                            //value={this.parseApiDate(this.state.schedularDate || null)}
                            value={this.formatDateString(this.state.schedularDate || null)}
                            //value={this.pacificFormatDateString(this.state.schedularDate || null)}
                            onChange={(date) =>
                              this.setState({
                                schedularDate: date,
                                sendLater: true,
                              })
                            }
                            InputLabelProps={{ shrink: true }}
                            disabled={this.state.emailSend === true}
                            minDate={new Date()} // optional: prevent past dates
                            invalidDateMessage="Invalid Date"
                          />
                        </MuiPickersUtilsProvider>

                        {!this.state.schedularDate && (
                          <FormHelperText error>Please select a date</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  )}


                </Box>

                {/* Contacts + Contact Type (New Dropdown) */}
                <Box display="flex" gap={2} mt={2}>
                  {/* Contacts Dropdown */}
                  <Box width={1} pr={2}>
                    <FormControl fullWidth>
                      <InputLabel>Contacts</InputLabel>
                      <Select
                        value={
                          this.state.contactList?.length > 0
                            ? this.state.patientContactId
                              ? String(this.state.patientContactId)
                              : this.state.contactList.find(c => c.isPrimary)?.patientContactId
                                ? String(this.state.contactList.find(c => c.isPrimary).patientContactId)
                                : ""
                            : ""
                        }
                        onChange={this.handleManualContactChange}
                        onOpen={() => {
                          this.fetchContacts();  // First function
                          //this.fetchPccContacts();  // Second function
                        }}
                        disabled={this.state.emailSend === true}
                      >
                        <MenuItem value="" disabled>None</MenuItem>
                        {(this.state.contactList || [])
                          .slice() // make a shallow copy to avoid mutating state
                          .sort((a, b) => {
                            if (this.state.hasSurvey) {
                              return b.isPrimary - a.isPrimary; // true (1) comes before false (0)
                            }
                            return 0; // no sorting if taskUpdate is true
                          })
                          .map((survey, i) => (
                            <MenuItem key={i} value={String(survey.patientContactId)}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div>
                                  {survey.contactName} -{survey.relationship}
                                  {survey.isPrimary && (
                                    <Chip
                                      size="small"
                                      label="Primary"
                                      color="primary"
                                      style={{ marginLeft: 8 }}
                                    />
                                  )}
                                </div>
                                {survey.contactType?.length > 0 && (
                                  <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                    {survey.contactType.map(ct => ct.contactType).join(", ")}
                                  </div>
                                )}
                              </div>
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions className="modal-actions" justify="center" >
            <div style={{ padding: '8px 24px', display: 'flex', justifyContent: 'end' }}>
              <Button
                type="submit"
                className="btn1"
                disabled={!this.validateForm() || this.state.loading}
              >
                {this.state.loading && (
                  <CircularProgress
                    size={24}
                    className="buttonProgress"
                    color="secondary"
                  />
                )}
                {this.state.taskUpdate ? "Update Task" : "New Task"}
              </Button>
              <Button
                onClick={() => {
                  this.resetState(); // Reset form fields
                  this.props.updatePatientModalClose(); // Then close the modal
                }}
                className="cancel-link"
                style={{ background: '#A9A9A9', borderRadius: '20px', height: '40px', color: 'white' }}
              >
                Cancel
              </Button>

            </div>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
export const PatientTasks = connect(mapStateToProps)(PatientTasksClass);
export default PatientTasks;
